export default __webpack_public_path__ + "static/media/line-3-left.6460725a.svg";